import React from "react";
import { t } from "ttag";

import { IUser } from "../../../models/user.interfaces";

interface IProps {
    user: IUser | null;
}

export const CSRHeader = (props: IProps): React.JSX.Element | null => {
    if (!props.user || !props.user.is_csr) {
        return null;
    }
    // TODO(i18n): Split logic - use first_name if available, otherwise use a separate translation for email fallback. Current implementation forces same sentence structure for both cases, which may not work in all languages.
    const name = props.user.first_name || props.user.email;
    return (
        <p>
            {t`Welcome, ${name}. Please complete the checkout form with the information of the customer you are assisting.`}
        </p>
    );
};
